<template>
    <div class="dispensing-item-preview">
        <div class="action">
            <span>{{ item.action }}</span>
        </div>
        <div class="reason">
            <div
                v-if="item.additional_data && item.additional_data.week && item.additional_data.type === 'monitoring'"
                class="monitoring"
            >
                <div class="grid-status">
                    <span>
                        {{ t('patients::monitoring.week', { week: nth(item.additional_data.week) }) }}
                    </span>
                </div>
            </div>
            <span>{{ item.memo_text }}</span>
        </div>
        <div
            v-if="
                item.related_record_id ||
                (item.additional_data && item.additional_data.type === 'blood-result') ||
                (item.additional_data && item.additional_data.adverse_event_id)
            "
            class="actions"
        >
            <v-btn
                v-if="item.additional_data && item.additional_data.adverse_event_id"
                rounded
                outlined
                small
                color="primary"
                class="mr-2"
                @click="switchToAeTab(item.additional_data.adverse_event_id)"
                >{{ t('patients::button.view_adverse_event') }}
            </v-btn>
            <v-btn
                v-if="item.related_record_id"
                rounded
                outlined
                small
                color="primary"
                class="mr-2"
                @click="switchToMemoTab(item.related_record_id)"
                >{{ t('patients::button.go_to_memos') }}
            </v-btn>
            <v-btn
                v-if="item.additional_data && item.additional_data.type === 'blood-result' && item.related_record_id"
                rounded
                outlined
                small
                color="primary"
                @click="switchToBloodResultTab(item.related_record_id)"
                >{{ t('patients::button.go_to_blood_result') }}
            </v-btn>
            <template v-if="item.additional_data && item.additional_data.type === 'treatment-break'">
                <treatment-break-dialog-form
                    v-if="can('api.v1.patients.dispensing-treatment-breaks.update')"
                    v-show="false"
                    :disabled="readOnlyRules"
                    :item="item"
                    :patient-id="patientId"
                    @success="timelineChanged()"
                >
                </treatment-break-dialog-form>
                <b-confirm
                    v-if="can('api.v1.patients.dispensing-treatment-breaks.delete')"
                    text="Are you sure you want to delete this treatment break record?"
                    title="Delete Treatment Break"
                    @true="deleteTimelineItem()"
                >
                    <template #additional-content>
                        <v-card-text>
                            <v-textarea
                                v-model="treatmentBreakReason"
                                label="Reason"
                                outlined
                                dense
                                rounded
                            ></v-textarea>
                        </v-card-text>
                    </template>
                    <template #button="{ on, dialog }">
                        <v-btn
                            icon
                            fab
                            x-small
                            rounded
                            outlined
                            color="primary"
                            :disabled="readOnlyRules"
                            class="mr-2"
                            v-on="on"
                            @click="dialog = true"
                        >
                            <v-icon dark small> mdi-delete</v-icon>
                        </v-btn>
                    </template>
                </b-confirm>
            </template>
        </div>
    </div>
</template>

<script>
import TreatmentBreakDialogForm from './forms/TreatmentBreakDialogForm.vue';

export default {
    components: { TreatmentBreakDialogForm },
    props: {
        item: {
            type: Object,
            required: true,
        },
        readOnlyRules: {
            type: Boolean,
            required: true,
            default: false,
        },
    },
    data() {
        return {
            treatmentBreakDialog: false,
            treatmentBreakReason: null,
        };
    },
    computed: {
        patientId() {
            return this.$store.state.patients.patient.id;
        },
    },
    methods: {
        timelineChanged() {
            this.$emit('timeline-changed');
        },
        deleteTimelineItem() {
            axios
                .post(
                    route('api.v1.patients.dispensing-treatment-breaks.delete', {
                        patient: this.patientId,
                        treatment_break: this.item.related_record_id,
                        reason: this.treatmentBreakReason,
                    }),
                    this.treatmentBreak
                )
                .then(() => {
                    this.timelineChanged();
                })
                .catch((error) => {
                    this.$root.notify('error', error.response.data.error);
                });
        },
        switchToAeTab(adverse_event_id) {
            this.$store.dispatch('patients/changeTab', 6);
            this.$store.dispatch('adverse_event/loadAdverseEvent', {
                patient_id: this.patientId,
                id: adverse_event_id,
            });
        },
        switchToMemoTab(related_record_id) {
            this.$store.dispatch('patients/switchToMemoTab', related_record_id);
        },
        switchToBloodResultTab(blood_result) {
            this.$store.dispatch('patients/resetErrorMessages');
            axios
                .get(
                    route('api.v1.patients.blood-results.show', {
                        patient: this.patientId,
                        blood_result: blood_result,
                        fields: '*,blood_result_provider_id,operator,editable,rejected,blood_result_provider.id,blood_result_provider.name,blood_result_provider.visible_in_qc_list,provider_type',
                    })
                )
                .then((response) => {
                    const data = response.data.data;
                    this.$store.dispatch('patients/loadBloodResult', data);
                    this.$store.dispatch('patients/changeTab', 4);
                });
        },
        nth: function (d) {
            let suffix = 'th';
            if (d <= 3 || d >= 21) {
                switch (d % 10) {
                    case 1:
                        suffix = 'st';
                        break;
                    case 2:
                        suffix = 'nd';
                        break;
                    case 3:
                        suffix = 'd';
                        break;
                }
            }
            return '' + d + suffix;
        },
    },
};
</script>
